export default __webpack_public_path__ + "static/media/Watch.3138d86d.jpg";